/**
 * OrganizationLocalizationsCtrl controller
 * Show all localizations for organization
 */

// controller mixins
OrganizationLocalizationsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * OrganizationLocalizationsCtrl controller
 *
 * @class OrganizationLocalizationsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:OrganizationLocalizationsCtrl
 */
/* @ngInject */
export default function OrganizationLocalizationsCtrl ($scope, Localization, authSvc, pckg, inapp) {
  var vm = this
  vm.mixes = [['tabsCtrlMixin', 'clients', 'applications']]

  vm.isFound = true
  vm.showShoppingCartTab = authSvc.hasEnabledFlag('FEATURE_SHOPPING_CART_MANAGEMENT_ENABLED') &&
    authSvc.hasEnabledFlag('FEATURE_SHOPPING_CART_LOCALIZATION_ENABLED')

  // Initialize activeTab if not set by mixin
  if (vm.activeTab === undefined) {
    vm.activeTab = 0
  }

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:OrganizationLocalizationsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:OrganizationLocalizationsCtrl
   * @type {number}
   */
  vm.inappNetworkId = !inapp?.multiorgEnabled && inapp?.inAppRegistrationSettings?.enabled && inapp.inAppRegistrationSettings.network?.id

  /**
   * Default Package for Guest Mode
   *
   * @memberof mwApp/packages.controller:OrganizationLocalizationsCtrl
   * @type {number}
   */
  vm.guestNetworkId = !inapp?.multiorgEnabled && inapp?.guestModeSettings?.enabled && inapp.guestModeSettings.network?.id

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true
  vm.localizationStatuses = {
    CREATING: 'Creating',
    UPDATING: 'Updating',
    DONE: 'Done'
  }

  /**
   * Devices list
   *
   * @memberof mwApp/packages.controller:OrganizationLocalizationsCtrl
   * @type {models.Localization[]}
   */
  vm.localizations = []

  /**
   * Get Localizations from backend
   *
   * @memberof mwApp/packages.controller:OrganizationLocalizationsCtrl
   */
  vm.getLocalizations = function () {
    // set default sort by id
    Localization.loadAll({ appName: 'client-apps', networkId: vm.pckg?.id })
      .then(
        data => {
          vm.clientLocalizations = data
          vm.clientLocalizationsIsFound = !!vm.clientLocalizations.length
          $scope.loading = false
        }
      )
  }
  vm.getLocalizations()
  if (vm.showShoppingCartTab) {
    /**
     * Get Localizations from backend
     *
     * @memberof mwApp/packages.controller:OrganizationLocalizationsCtrl
     */
    vm.getApplicationLocalizations = function () {
      // set default sort by id
      Localization.loadAll({ appName: 'scp', networkId: vm.pckg?.id })
        .then((data) => {
          vm.applicationLocalizations = data
          vm.applicationLocalizationsIsFound = !!vm.applicationLocalizations.length
          $scope.loading = false
        })
    }
    vm.getApplicationLocalizations()
  }

  /**
   * Set payment as default
   *
   * @memberof mwApp/packages.controller:OrganizationLocalizationsCtrl
   * @param  {models.Localization} localization
   * @param  {String} appName
   */
  vm.setDefault = function (localization, appName) {
    localization._default()
      .then(() => {
        if (appName === 'client-apps') {
          vm.getLocalizations()
        } else {
          vm.getApplicationLocalizations()
        }
      })
  }

  /**
   * Delete Localization
   *
   * @memberof mwApp/packages.controller:OrganizationLocalizationsCtrl
   * @param {models.Localization} localization
   */
  vm.delete = function (localization) {
    localization._delete()
      .then(() => {
        vm.getLocalizations()
        if (vm.showShoppingCartTab) {
          vm.getApplicationLocalizations()
        }
      })
  }

  $scope.$on('$destroy', function () {
    window.clearTimeout(vm.$timer)
  })
}
